import React from "react";
import { GridContainer } from "./MonthlyReport.styles";
import MonthlyReportSummary from "./MonthlyReport.summary";
import MonthlyReportFeesBreakdown from "./MonthlyReport.feesBreakdown";
import MonthlyReportCommissionConfig from "./MonthlyReport.commissionConfig";

const MonthlyReportMerchant = ({ reportData }) => {
  const { summary, commission_config } = reportData;

  return (
    <GridContainer spacing={0}>
      <MonthlyReportSummary summary={summary} />
      <MonthlyReportFeesBreakdown summary={summary} />
      <MonthlyReportCommissionConfig commission_config={commission_config} userType="merchant" />
    </GridContainer>
  );
};

export default MonthlyReportMerchant;

